<template>
  <div>
    <div class="office">
      <p class="userInfo">办公场所</p>
      <el-table border :data="tableData">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column label="实际办公地址" width="350">
          <template slot-scope="scope">
            <!-- <el-cascader :props="props" v-model="nation" @change="handleChange"></el-cascader> -->
            <el-input v-model="nationData" placeholder="请选择"></el-input>
            <el-cascader :props="props" v-model="nation" @change="handleChange" ref="cInput" class="cInput">
            </el-cascader>
          </template>
        </el-table-column>
        <el-table-column label="具体办公地址(精确到门牌号)" width="300">
          <template slot-scope="scope">
            <el-input v-model="officeData.realOfficeAddress" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="办公面积(平方米)" width="auto">
          <template slot-scope="scope">
            <el-input v-model="officeData.officeArea" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="办公场地租赁合同/房产证复印件附件" width="300">
          <template slot-scope="scope">
            <span>{{ officeData.officRentOrignName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="附件上传" width="150">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="input">
              上传
              <input
                type="file"
                class="file"
                @change="getOfficeFile($event, scope)"
                accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
              />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="downLoadDisabled"
              @click="downFileOffice(scope.row)"
              style="font-size: 14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="info">
      <p class="userInfo">其他信息</p>
      <table-temp :tableData="otherData" :columnData="step4Other" :isEdit="false">
        <template slot="other">
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <a href="javascript:void(0);" class="input" style="color: #3156ff">
                上传
                <input
                  type="file"
                  class="file"
                  @change="getOtherFile($event, scope)"
                  accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
                />
              </a>
            </template>
          </el-table-column>
          <el-table-column label="下载附件" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                :disabled="scope.row.newFile ? false : true"
                @click="downFile(scope.row)"
                style="font-size: 14px"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </template>
      </table-temp>
    </div>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="DoDebounce(save, 'timer7')">保存</el-button>
      <el-button class="mainBtn" @click="DoDebounce(next, 'timer8')">保存并提交</el-button>
    </div>
  </div>
</template>

<script>
import TableTemp from '../table2'
import { step4, step4Company, step4Other } from '@/conf/newAgency'
import { otherInfoItem2, otherInfoItemManage } from '@/conf/AgencyConf'
import comMixin from 'common/js/mixin/comMixin'
import { debounce } from 'common/js/tools.js'
import {
  nation,
  singleUpload,
  addOtherInfo,
  submitMgr,
  getDetailAorManager,
  institutionDownLoadCommon,
  getOtherInfo
} from 'common/js/api'

export default {
  components: {
    TableTemp
  },

  mixins: [comMixin],

  data() {
    return {
      codeId: this.$route.query.codeId,
      that: this,
      step: 3,
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const { level } = node
          let id
          if (node.level == 0) {
            id = 0
          } else id = node.data.id
          const res = await nation(id)

          const nodes = res.result.map(item => ({
            id: item.id,
            value: item.district,
            label: item.district,
            leaf: level >= 2
          }))
          resolve(nodes)
          this.getDetail()
        }
      },
      tableData: [
        {
          id: 0
        }
      ],
      officeData: {
        // realOfficeAddress: "",
        // officeArea: "",
        // officeProvince: "",
        // officCity: "",
        // officDistrict: "",
        // officRentOrignName: "",
      },
      tableConf: step4,
      nation: ['北京市', '北京', '西城区'],
      nationData: '',
      uploadData: {
        //办公租赁合同
        officRentOrignName: '',
        officRentStorePath: ''
      },
      step4Company,
      companyData: [
        {
          id: 0,
          name: '公司章程或合伙协议',
          oldFile: '',
          newFile: ''
        },
        {
          id: 1,
          name: '核名通知书',
          oldFile: '',
          newFile: ''
        }
      ],
      step4Other,
      otherData: otherInfoItem2,
      isAgency: false,
      downLoadDisabled: false
    }
  },

  mounted() {
    // this.getDetail();
    this.isAgency = this.$route.path == '/FundManagement/NewAgency' ? false : true
    if (!this.isAgency) {
      this.otherData = otherInfoItemManage
    }
    this.resetCompanyData()
  },

  methods: {
    resetCompanyData() {
      if (this.isAgency) {
        switch (this.Cookies.get('fundType')) {
          case '私募股权投资基金':
            this.otherData = [
              {
                id: 0,
                name: '入驻申请书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 1,
                name: '公司章程或合伙协议',
                oldFile: '',
                newFile: ''
              },

              {
                id: 4,
                name: '私募基金管理人营业执照',
                oldFile: '',
                newFile: ''
              },
              {
                id: 5,
                name: '中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 6,
                name: '管理人备案承诺书（已备案无须提供，新设必须提供）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 15,
                name: '其他材料',
                oldFile: '',
                newFile: ''
              }
            ]
            break
          case '创业投资基金':
            this.otherData = [
              {
                id: 0,
                name: '入驻申请书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 1,
                name: '公司章程或合伙协议',
                oldFile: '',
                newFile: ''
              },

              {
                id: 4,
                name: '私募基金管理人营业执照',
                oldFile: '',
                newFile: ''
              },
              {
                id: 5,
                name: '中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 6,
                name: '管理人备案承诺书（已备案无须提供，新设必须提供）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 15,
                name: '其他材料',
                oldFile: '',
                newFile: ''
              }
            ]
            break
          case '私募证券投资基金':
            this.otherData = [
              {
                id: 0,
                name: '入驻申请书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 1,
                name: '公司章程或合伙协议',
                oldFile: '',
                newFile: ''
              },

              {
                id: 4,
                name: '私募基金管理人营业执照',
                oldFile: '',
                newFile: ''
              },
              {
                id: 5,
                name: '中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 6,
                name: '管理人备案承诺书（已备案无须提供，新设必须提供）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 7,
                name: '第三方托管意向书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 15,
                name: '其他材料',
                oldFile: '',
                newFile: ''
              }
            ]
            break
          case '持股平台':
            this.otherData = [
              {
                id: 0,
                name: '入驻申请书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 1,
                name: '公司章程或合伙协议',
                oldFile: '',
                newFile: ''
              },
              {
                id: 8,
                name: '佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）',
                oldFile: '',
                newFile: ''
              },
              {
                id: 9,
                name: '主体公司关于同意设立持股平台的股东会决议',
                oldFile: '',
                newFile: ''
              },
              {
                id: 10,
                name: '被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料',
                oldFile: '',
                newFile: ''
              },
              {
                id: 11,
                name: '主体公司商事变更登记承诺书',
                oldFile: '',
                newFile: ''
              },
              {
                id: 15,
                name: '其他材料',
                oldFile: '',
                newFile: ''
              }
            ]
            break
          case '自有资金投资类企业':
            this.otherData = [
              {
                id: 0,
                name: '入驻申请书',
                oldFile: '--',
                newFile: ''
              },
              {
                id: 1,
                name: '公司章程或合伙协议',
                oldFile: '--',
                newFile: ''
              },
              {
                id: 14,
                name: '其他材料',
                oldFile: '--',
                newFile: ''
              }
            ]
            break
        }
      }
    },
    async downFileOffice(row) {
      // const fileData = this.uploadData.officRentStorePath.split("/");
      // const suffix = fileData[3].split(".");
      // await downLoadCommon(
      //   fileData[0],
      //   suffix[1],
      //   this.uploadData.officRentOrignName,
      //   suffix[0]
      // );

      const filePath = this.officeData.officRentStorePath
      const fileName = this.officeData.officRentOrignName
      console.log('@@officeData', this.officeData)
      console.log('@@filePath', filePath)
      console.log('@@fileName', fileName)
      const params = {
        filePath: filePath,
        fileName: fileName
      }
      await institutionDownLoadCommon(params)
    },
    DoDebounce(func, timer) {
      debounce(func, 2000, timer, true)
    },
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = fileData[3].split(".");
      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
      const filePath = row.newFile
      const fileName = row.oldFile
      console.log('@@row', row)
      console.log('@@filePath', filePath)
      console.log('@@fileName', fileName)
      const params = {
        filePath: filePath,
        fileName: fileName
      }
      await institutionDownLoadCommon(params)
    },

    async getDetail() {
      const { result } = await getOtherInfo(this.codeId)

      // const { result } = await getDetailAorManager(
      //   this.$route.path,
      //   this.codeId
      // );
      //this.setDetail(result);

      if (result.office && Object.keys(result.office).length) {
        this.setOfficeDetail(result)
      }
      if (result.other && Object.keys(result.other).length) {
        this.setOtherDetail(result)
      }
      this.officeData.officRentOrignName ? (this.downLoadDisabled = false) : (this.downLoadDisabled = true)
    },
    setOfficeDetail(data) {
      this.officeData = data.office[0]
      // this.officeData.realOfficeAddress = data.realOfficeAddress;
      // this.officeData.officRentOrignName = data.officRentOrignName;
      // this.officeData.officeArea = data.officeArea;
      // this.officeData.officDistrict = data.officDistrict;
      // this.officeData.officeProvince = data.officeProvince;
      // this.officeData.officCity = data.officCity;
      this.nation = [data.office[0].officeProvince, data.office[0].officCity, data.office[0].officDistrict]
      this.nation = []
      this.nation.push(data.office[0].officeProvince)
      this.nation.push(data.office[0].officCity)
      this.nation.push(data.office[0].officDistrict)

      this.nationData = this.nation.join('/') == '//' ? '' : this.nation.join('/')
      // ["北京市", "北京", "西城区", __ob__: Observer]
      this.uploadData.officRentOrignName = data.office[0].officRentOrignName
      this.uploadData.officRentStorePath = data.office[0].officRentStorePath
    },
    setOtherDetail(data) {
      if (this.isAgency) {
        switch (this.Cookies.get('fundType')) {
          case '私募股权投资基金':
            //入驻申请书
            this.otherData[0].oldFile = data.other[0].inApplicationOrignName
            this.otherData[0].newFile = data.other[0].inApplicationStorePath
            //公司章程或合伙协议
            this.otherData[1].oldFile = data.other[0].regulationOrignName
            this.otherData[1].newFile = data.other[0].regulationStorePath
            //私募基金管理人营业执照
            this.otherData[2].oldFile = data.other[0].smfundMgrPicOrignName
            this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherData[3].oldFile = data.other[0].associationRegisteFileOrignName
            this.otherData[3].newFile = data.other[0].associationRegisteFileStorePath
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherData[4].oldFile = data.other[0].mgrPromiseFileOrignName
            this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath
            //其他材料
            this.otherData[5].oldFile = data.other[0].otherFileOrignName
            this.otherData[5].newFile = data.other[0].otherFileStorePath

            break
          case '创业投资基金':
            //入驻申请书
            this.otherData[0].oldFile = data.other[0].inApplicationOrignName
            this.otherData[0].newFile = data.other[0].inApplicationStorePath
            //公司章程或合伙协议
            this.otherData[1].oldFile = data.other[0].regulationOrignName
            this.otherData[1].newFile = data.other[0].regulationStorePath
            //私募基金管理人营业执照
            this.otherData[2].oldFile = data.other[0].smfundMgrPicOrignName
            this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherData[3].oldFile = data.other[0].associationRegisteFileOrignName
            this.otherData[3].newFile = data.other[0].associationRegisteFileStorePath
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherData[4].oldFile = data.other[0].mgrPromiseFileOrignName
            this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath
            //其他材料
            this.otherData[5].oldFile = data.other[0].otherFileOrignName
            this.otherData[5].newFile = data.other[0].otherFileStorePath
            break
          case '私募证券投资基金':
            //入驻申请书
            this.otherData[0].oldFile = data.other[0].inApplicationOrignName
            this.otherData[0].newFile = data.other[0].inApplicationStorePath
            //公司章程或合伙协议
            this.otherData[1].oldFile = data.other[0].regulationOrignName
            this.otherData[1].newFile = data.other[0].regulationStorePath
            //私募基金管理人营业执照
            this.otherData[2].oldFile = data.other[0].smfundMgrPicOrignName
            this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherData[3].oldFile = data.other[0].associationRegisteFileOrignName
            this.otherData[3].newFile = data.other[0].associationRegisteFileStorePath
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherData[4].oldFile = data.other[0].mgrPromiseFileOrignName
            this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath
            //第三方托管意向书
            this.otherData[5].oldFile = data.other[0].sfTrustedFileOrignName
            this.otherData[5].newFile = data.other[0].sfTrustedFileStorePath
            //其他材料
            this.otherData[6].oldFile = data.other[0].otherFileOrignName
            this.otherData[6].newFile = data.other[0].otherFileStorePath
            break
          case '持股平台':
            // 入驻申请书
            this.otherData[0].oldFile = data.other[0].inApplicationOrignName
            this.otherData[0].newFile = data.other[0].inApplicationStorePath
            //公司章程或合伙协议
            this.otherData[1].oldFile = data.other[0].regulationOrignName
            this.otherData[1].newFile = data.other[0].regulationStorePath

            // 佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）
            //其他材料
            this.otherData[2].oldFile = data.other[0].evidenceFileOrignName
            this.otherData[2].newFile = data.other[0].evidenceFileStorePath
            // 主体公司关于同意设立持股平台的股东会决议
            this.otherData[3].oldFile = data.other[0].gdhDecisionOrignName
            this.otherData[3].newFile = data.other[0].gdhDecisionStorePath
            // 被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料
            this.otherData[4].oldFile = data.other[0].newImportEvidenceOrignName
            this.otherData[4].newFile = data.other[0].newImportEvidenceStorePath
            // 主体公司商事变更登记承诺书
            this.otherData[5].oldFile = data.other[0].changeRegistedFileOrignName
            this.otherData[5].newFile = data.other[0].changeRegistedFileStorePath
            //其他材料
            this.otherData[6].oldFile = data.other[0].otherFileOrignName
            this.otherData[6].newFile = data.other[0].otherFileStorePath
            break
          case '自有资金投资类企业':
            // 入驻申请书
            this.otherData[0].oldFile = data.other[0].inApplicationOrignName
            this.otherData[0].newFile = data.other[0].inApplicationStorePath
            //公司章程或合伙协议
            this.otherData[1].oldFile = data.other[0].regulationOrignName
            this.otherData[1].newFile = data.other[0].regulationStorePath
            // 其他材料（至少三年。。）
            this.otherData[2].oldFile = data.other[0].otherFileOrignName
            this.otherData[2].newFile = data.other[0].otherFileStorePath

            break
        }
      } else {
        //入驻申请书
        this.otherData[0].oldFile = data.other[0].inApplicationOrignName
        this.otherData[0].newFile = data.other[0].inApplicationStorePath
        //公司章程或合伙协议
        this.otherData[1].oldFile = data.other[0].regulationOrignName
        this.otherData[1].newFile = data.other[0].regulationStorePath
        //展业计划书/商业计划书
        this.otherData[2].oldFile = data.other[0].planFileOrignName
        this.otherData[2].newFile = data.other[0].planFileStorePath
        //私募基金管理人股权架构合理性说明（如设置超过三层）
        this.otherData[3].oldFile = data.other[0].rationalityExplainOrignName
        this.otherData[3].newFile = data.other[0].rationalityExplainStorePath
        //其他材料
        this.otherData[4].oldFile = data.other[0].otherFileOrignName
        this.otherData[4].newFile = data.other[0].otherFileStorePath
      }
    },

    async next() {
      const isValidate = await this.save()
      if (!isValidate) return false
      const result = await submitMgr(this.codeId)

      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: this.step + 1
        }
      })
      this.$emit('next', this.codeId)
    },

    handleChange() {
      this.officeData.officeProvince = this.nation[0]
      this.officeData.officCity = this.nation[1]
      this.officeData.officDistrict = this.nation[2]
      this.nationData = this.nation.join('/')
    },

    async getInfoComFile(event, scope) {
      const index = scope.$index
      this.file = event.target.files[0]
      if (this.file) {
        const res = await this.submitUpload(event)

        this.companyData[index].oldFile = res.result.orignName
        this.companyData[index].newFile = res.result.storePath
      }
    },

    // getOfficeFile
    async getOfficeFile(event) {
      let file = event.target.files[0]
      let fileName = file.name
      if (file) {
        let idx = fileName.lastIndexOf('.')
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase()
          ext = ext.toLowerCase()
          if (
            // ext != "bmp" &&
            // ext != "jpg" &&
            // ext != "png" &&
            // ext != "jpeg" &&
            // ext != "gif" &&
            // ext != "webp" &&
            // ext != "svg" &&
            // ext != "tiff" &&
            // ext != "pjp" &&
            // ext != "jfif" &&
            // ext != "xbm" &&
            // ext != "dib" &&
            // ext != "jxl" &&
            // ext != "svgz" &&
            // ext != "tif" &&
            // ext != "pjpeg" &&
            // ext != "avif"&&
            ext != 'pdf' &&
            ext != 'rar' &&
            ext != 'zip'
          ) {
            this.$message.error('请上传格式正确的文件，支持pdf、rar和zip')
          } else {
            this.file = file
            if (this.file) {
              const res = await this.submitUpload(event)
              this.uploadData.officRentOrignName = res.result.orignName
              this.uploadData.officRentStorePath = res.result.storePath
              // this.officeData.officRentOrignName = res.result.orignName;
              this.$set(this.officeData, 'officRentOrignName', res.result.orignName)
            }
          }
        }
      }
    },

    // getOtherFile
    async getOtherFile(event, scope) {
      const index = scope.$index
      let file = event.target.files[0]
      let fileName = file.name
      if (file) {
        let idx = fileName.lastIndexOf('.')
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase()
          ext = ext.toLowerCase()
          if (
            // ext != "bmp" &&
            // ext != "jpg" &&
            // ext != "png" &&
            // ext != "jpeg" &&
            // ext != "gif" &&
            // ext != "webp" &&
            // ext != "svg" &&
            // ext != "tiff" &&
            // ext != "pjp" &&
            // ext != "jfif" &&
            // ext != "xbm" &&
            // ext != "dib" &&
            // ext != "jxl" &&
            // ext != "svgz" &&
            // ext != "tif" &&
            // ext != "pjpeg" &&
            // ext != "avif"&&
            ext != 'pdf' &&
            ext != 'rar' &&
            ext != 'zip'
          ) {
            this.$message.error('请上传格式正确的文件，支持pdf、rar和zip')
          } else {
            this.file = file
            if (this.file) {
              const res = await this.submitUpload(event)
              this.otherData[index].oldFile = res.result.orignName
              this.otherData[index].newFile = res.result.storePath
            }
          }
        }
      }
    },

    async submitUpload(event) {
      event.preventDefault()
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('ftCode', this.Cookies.get('selectedBasicFtCode'))
      formData.append('institutionName', this.Cookies.get('institutionName'))
      const result = await singleUpload(formData)
      this.$message({
        message: '上传成功',
        type: 'success'
      })
      return result
    },

    async save() {
      const updata = {
        infoType: 1,
        //办公租赁合同
        officRentOrignName: this.uploadData.officRentOrignName,
        officRentStorePath: this.uploadData.officRentStorePath
      }
      let otherdata
      if (this.isAgency) {
        switch (this.Cookies.get('fundType')) {
          case '私募股权投资基金':
            otherdata = {
              infoType: 2,
              //入驻申请书
              inApplicationOrignName: this.otherData[0].oldFile,
              inApplicationStorePath: this.otherData[0].newFile,
              //公司章程或合伙协议
              regulationOrignName: this.otherData[1].oldFile,
              regulationStorePath: this.otherData[1].newFile,
              //私募基金管理人营业执照
              smfundMgrPicOrignName: this.otherData[2].oldFile,
              smfundMgrPicStorePath: this.otherData[2].newFile,
              //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
              associationRegisteFileOrignName: this.otherData[3].oldFile,
              associationRegisteFileStorePath: this.otherData[3].newFile,
              //管理人备案承诺书（已备案无须提供，新设必须提供）
              mgrPromiseFileOrignName: this.otherData[4].oldFile,
              mgrPromiseFileStorePath: this.otherData[4].newFile,
              //其他材料
              otherFileOrignName: this.otherData[5].oldFile,
              otherFileStorePath: this.otherData[5].newFile
            }
            break
          case '创业投资基金':
            otherdata = {
              infoType: 2,
              //入驻申请书
              inApplicationOrignName: this.otherData[0].oldFile,
              inApplicationStorePath: this.otherData[0].newFile,
              //公司章程或合伙协议
              regulationOrignName: this.otherData[1].oldFile,
              regulationStorePath: this.otherData[1].newFile,
              //私募基金管理人营业执照
              smfundMgrPicOrignName: this.otherData[2].oldFile,
              smfundMgrPicStorePath: this.otherData[2].newFile,
              //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
              associationRegisteFileOrignName: this.otherData[3].oldFile,
              associationRegisteFileStorePath: this.otherData[3].newFile,
              //管理人备案承诺书（已备案无须提供，新设必须提供）
              mgrPromiseFileOrignName: this.otherData[4].oldFile,
              mgrPromiseFileStorePath: this.otherData[4].newFile,
              //其他材料
              otherFileOrignName: this.otherData[5].oldFile,
              otherFileStorePath: this.otherData[5].newFile
            }
            break
          case '私募证券投资基金':
            otherdata = {
              infoType: 2,
              //入驻申请书
              inApplicationOrignName: this.otherData[0].oldFile,
              inApplicationStorePath: this.otherData[0].newFile,
              //公司章程或合伙协议
              regulationOrignName: this.otherData[1].oldFile,
              regulationStorePath: this.otherData[1].newFile,
              //私募基金管理人营业执照
              smfundMgrPicOrignName: this.otherData[2].oldFile,
              smfundMgrPicStorePath: this.otherData[2].newFile,
              //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
              associationRegisteFileOrignName: this.otherData[3].oldFile,
              associationRegisteFileStorePath: this.otherData[3].newFile,
              //管理人备案承诺书（已备案无须提供，新设必须提供）
              mgrPromiseFileOrignName: this.otherData[4].oldFile,
              mgrPromiseFileStorePath: this.otherData[4].newFile,

              //第三方托管意向书
              sfTrustedFileOrignName: this.otherData[5].oldFile,
              sfTrustedFileStorePath: this.otherData[5].newFile,

              //其他材料
              otherFileOrignName: this.otherData[6].oldFile,
              otherFileStorePath: this.otherData[6].newFile
            }

            break
          case '持股平台':
            otherdata = {
              infoType: 2,
              // 入驻申请书
              inApplicationOrignName: this.otherData[0].oldFile,
              inApplicationStorePath: this.otherData[0].newFile,
              //公司章程或合伙协议
              regulationOrignName: this.otherData[1].oldFile,
              regulationStorePath: this.otherData[1].newFile,
              // 佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）
              //其他材料
              evidenceFileOrignName: this.otherData[2].oldFile,
              evidenceFileStorePath: this.otherData[2].newFile,
              // 主体公司关于同意设立持股平台的股东会决议
              gdhDecisionOrignName: this.otherData[3].oldFile,
              gdhDecisionStorePath: this.otherData[3].newFile,
              // 被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料
              newImportEvidenceOrignName: this.otherData[4].oldFile,
              newImportEvidenceStorePath: this.otherData[4].newFile,
              // 主体公司商事变更登记承诺书
              changeRegistedFileOrignName: this.otherData[5].oldFile,
              changeRegistedFileStorePath: this.otherData[5].newFile,
              //其他材料
              otherFileOrignName: this.otherData[6].oldFile,
              otherFileStorePath: this.otherData[6].newFile
            }
            break
          case '自有资金投资类企业':
            otherdata = {
              infoType: 2,
              // 入驻申请书
              inApplicationOrignName: this.otherData[0].oldFile,
              inApplicationStorePath: this.otherData[0].newFile,
              //公司章程或合伙协议
              regulationOrignName: this.otherData[1].oldFile,
              regulationStorePath: this.otherData[1].newFile,
              // 其他材料（至少三年。。）
              otherFileOrignName: this.otherData[2].oldFile,
              otherFileStorePath: this.otherData[2].newFile
            }

            break
        }
      } else {
        otherdata = {
          infoType: 2,
          //入驻申请书
          inApplicationOrignName: this.otherData[0].oldFile,
          inApplicationStorePath: this.otherData[0].newFile,
          //公司章程或合伙协议
          regulationOrignName: this.otherData[1].oldFile,
          regulationStorePath: this.otherData[1].newFile,
          //展业计划书/商业计划书
          planFileOrignName: this.otherData[2].oldFile,
          planFileStorePath: this.otherData[2].newFile,
          //私募基金管理人股权架构合理性说明（如设置超过三层）
          rationalityExplainOrignName: this.otherData[3].oldFile,
          rationalityExplainStorePath: this.otherData[3].newFile,
          //其他材料
          otherFileOrignName: this.otherData[4].oldFile,
          otherFileStorePath: this.otherData[4].newFile
        }
      }

      const data1 = Object.assign(this.officeData, updata, {
        institutionCode: this.codeId
      })
      const data2 = Object.assign(otherdata, {
        institutionCode: this.codeId
      })
      const dataList = []
      dataList.push(data1)
      dataList.push(data2)
      const result = await addOtherInfo(dataList)
      // await addOtherInfo(data2);
      this.$message({
        message: '保存成功!',
        type: 'success'
      })
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  padding-bottom: 50px;
}

.userInfo {
  margin: 20px 0px;
}

/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  margin-top: 1px;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #3165ff !important;
  position: absolute !important;
  /* right: 0px; */

  top: 10px;
  text-align: left !important;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.cInput {
  position: absolute !important;
  right: 20px !important;
}

.cInput ::v-deep  .el-input__inner {
  border: 0px !important;
  height: 20px !important;
  width: 300px !important;
  color: #60626600 !important;
  background-color: #82717100 !important;
}

.cInput ::v-deep  .el-input__inner ::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #60626600 !important;
}

.input-form ::v-deep  a {
  color: #3165ff;
}

::v-deep .type-title {
  &::before {
    display: none;
  }
}
</style>
